export function isEscapedInJson(char: string): boolean {
  // Intl.Segmenter() is used to split string with emojis. `.split()` is returning array with two elements for one emoji.
  const splitChars = [...new (Intl as any).Segmenter().segment(char)].map(x => x.segment);

  if (splitChars.length !== 1) {
    throw new Error('Input must be a single character.');
  }

  // Stringify character and remove quotes
  const jsonStringifiedChar = JSON.stringify(char);
  const stringifiedChar = jsonStringifiedChar.substring(1, jsonStringifiedChar.length - 1);

  return char !== stringifiedChar;
}
